/*** IMPORTS FROM imports-loader ***/
(function() {

define([],
    function () {
        var getImageForValue = function getImageForValue(value) {
          switch(value) {
            case 'Exterior_Paint':
              return 'https://assets.homedepot-static.com/p/static/images/paint/exterior-paint-tile.png';
            case 'Interior_Paint':
              return 'https://assets.homedepot-static.com/p/static/images/paint/interior-paint-tile.png';
            case 'BEHR_MARQUEE':
              return 'https://assets.homedepot-static.com/p/static/images/paint/behr-marquee-tile.png';
            case 'BEHR_ULTRA':
              return 'https://assets.homedepot-static.com/p/static/images/paint/behr-ultra-tile.png';
            case 'BEHR_PREMIUM_PLUS':
              return 'https://assets.homedepot-static.com/p/static/images/paint/behr-premium-plus-tile.png';
            case 'Flat/Matte':
              return 'https://assets.homedepot-static.com/p/static/images/paint/flat-matte-tile.png';
            case 'Flat_Enamel':
              return 'https://assets.homedepot-static.com/p/static/images/paint/flat-enamel-tile.png';
            case 'Eggshell':
              return 'https://assets.homedepot-static.com/p/static/images/paint/eggshell-tile.png';
            case 'Satin':
              return 'https://assets.homedepot-static.com/p/static/images/paint/satin-tile.png';
            case 'Semi-Gloss':
              return 'https://assets.homedepot-static.com/p/static/images/paint/semi-gloss-tile.png';
            case 'High-Gloss':
              return 'https://assets.homedepot-static.com/p/static/images/paint/high-gloss-tile.png';
            case '8_OZ-Sample':
              return 'https://assets.homedepot-static.com/p/static/images/paint/8-oz-sample-tile.png';
            case '1_QT-Quart':
              return 'https://assets.homedepot-static.com/p/static/images/paint/1-qt-quart-tile.png';
            case '1_GA-Gallon':
              return 'https://assets.homedepot-static.com/p/static/images/paint/1-ga-gallon-tile.png';
            case '5_GA-Gallon':
              return 'https://assets.homedepot-static.com/p/static/images/paint/5-ga-gallon-tile.png';
            case 'PPG_TIMELESS':
              return 'https://assets.homedepot-static.com/p/static/images/paint/ppg-timeless-tile.png';
            case 'PPG_Diamond':
              return 'https://assets.homedepot-static.com/p/static/images/paint/ppg-diamond-tile.png';
            case 'Glidden_Premium':
              return 'https://assets.homedepot-static.com/p/static/images/paint/glidden-premium-tile.png';
            case 'Glidden_Essentials':
              return 'https://assets.homedepot-static.com/p/static/images/paint/glidden-essentials-tile.png';
            default:
              return null;
          }
        }

        return {
            getImageForValue: getImageForValue
        }
    });

}.call(window));